// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1a5v0","aside":"styles_aside__2h7B0","reconnect_banner":"styles_reconnect_banner__1LFmw"};